// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/rfi_source_versions.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.RfiSourceChange
 */ export class RfiSourceChange extends Message {
    static fromBinary(bytes, options) {
        return new RfiSourceChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSourceChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSourceChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSourceChange, a, b);
    }
    constructor(data){
        super(), /**
   * added | removed | modified
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * date | question | requirement | other
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string before = 3;
   */ _define_property(this, "before", ""), /**
   * @generated from field: string after = 4;
   */ _define_property(this, "after", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSourceChange, "runtime", proto3);
_define_property(RfiSourceChange, "typeName", "mono.datagateway.v1.RfiSourceChange");
_define_property(RfiSourceChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "before",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiSourceVersion
 */ export class RfiSourceVersion extends Message {
    static fromBinary(bytes, options) {
        return new RfiSourceVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSourceVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSourceVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSourceVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version_no = 2;
   */ _define_property(this, "versionNo", 0), /**
   * Empty for the original source; otherwise the id of the version this amends.
   *
   * @generated from field: string prior_version_id = 3;
   */ _define_property(this, "priorVersionId", ""), /**
   * original | amendment
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 6;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string sha256 = 7;
   */ _define_property(this, "sha256", ""), /**
   * computed | unavailable (e.g. a binary format the diff cannot read)
   *
   * @generated from field: string diff_state = 8;
   */ _define_property(this, "diffState", ""), /**
   * @generated from field: string diff_error = 9;
   */ _define_property(this, "diffError", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSourceChange changes = 10;
   */ _define_property(this, "changes", []), /**
   * Questions and outline sections whose source wording was removed or modified.
   *
   * @generated from field: repeated string affected_question_ids = 11;
   */ _define_property(this, "affectedQuestionIds", []), /**
   * @generated from field: repeated string affected_section_ids = 12;
   */ _define_property(this, "affectedSectionIds", []), /**
   * pending | accepted | rejected. Only an explicit human action leaves pending.
   *
   * @generated from field: string review_state = 13;
   */ _define_property(this, "reviewState", ""), /**
   * @generated from field: string reviewed_by = 14;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 15;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string created_by = 16;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSourceVersion, "runtime", proto3);
_define_property(RfiSourceVersion, "typeName", "mono.datagateway.v1.RfiSourceVersion");
_define_property(RfiSourceVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_no",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "prior_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "diff_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "diff_error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "changes",
            kind: "message",
            T: RfiSourceChange,
            repeated: true
        },
        {
            no: 11,
            name: "affected_question_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "affected_section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSourceVersionsRequest
 */ export class ListRfiSourceVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSourceVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSourceVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSourceVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSourceVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSourceVersionsRequest, "runtime", proto3);
_define_property(ListRfiSourceVersionsRequest, "typeName", "mono.datagateway.v1.ListRfiSourceVersionsRequest");
_define_property(ListRfiSourceVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiSourceVersionsResponse
 */ export class ListRfiSourceVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSourceVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSourceVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSourceVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSourceVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSourceVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSourceVersionsResponse, "runtime", proto3);
_define_property(ListRfiSourceVersionsResponse, "typeName", "mono.datagateway.v1.ListRfiSourceVersionsResponse");
_define_property(ListRfiSourceVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: RfiSourceVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiSourceVersionRequest
 */ export class RecordRfiSourceVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSourceVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSourceVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSourceVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSourceVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * The version the diff was computed against; must still be the latest.
   *
   * @generated from field: string prior_version_id = 5;
   */ _define_property(this, "priorVersionId", ""), /**
   * @generated from field: string diff_state = 6;
   */ _define_property(this, "diffState", ""), /**
   * @generated from field: string diff_error = 7;
   */ _define_property(this, "diffError", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiSourceChange changes = 8;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSourceVersionRequest, "runtime", proto3);
_define_property(RecordRfiSourceVersionRequest, "typeName", "mono.datagateway.v1.RecordRfiSourceVersionRequest");
_define_property(RecordRfiSourceVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "prior_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "diff_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "diff_error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "changes",
            kind: "message",
            T: RfiSourceChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiSourceVersionResponse
 */ export class RecordRfiSourceVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiSourceVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiSourceVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiSourceVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiSourceVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSourceVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiSourceVersionResponse, "runtime", proto3);
_define_property(RecordRfiSourceVersionResponse, "typeName", "mono.datagateway.v1.RecordRfiSourceVersionResponse");
_define_property(RecordRfiSourceVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiSourceVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiSourceVersionRequest
 */ export class ReviewRfiSourceVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiSourceVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiSourceVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiSourceVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiSourceVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string version_id = 4;
   */ _define_property(this, "versionId", ""), /**
   * accepted | rejected
   *
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiSourceVersionRequest, "runtime", proto3);
_define_property(ReviewRfiSourceVersionRequest, "typeName", "mono.datagateway.v1.ReviewRfiSourceVersionRequest");
_define_property(ReviewRfiSourceVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiSourceVersionResponse
 */ export class ReviewRfiSourceVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiSourceVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiSourceVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiSourceVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiSourceVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiSourceVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiSourceVersionResponse, "runtime", proto3);
_define_property(ReviewRfiSourceVersionResponse, "typeName", "mono.datagateway.v1.ReviewRfiSourceVersionResponse");
_define_property(ReviewRfiSourceVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiSourceVersion
        }
    ]));
